export { default } from "./Searchbox";



// WEBPACK FOOTER //
// ./src/components/sale/posSection/searchbox/index.js